import React from 'react';
import Header from '../components/Header';
import LeftSide from '../components/LeftSide';
import {isAllowed} from '../authentication';

import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';

const Layout = (props) => {
    isAllowed(props);
    
    return (<>
        <LeftSide />
        <Header />
        <div className="br-mainpanel">
            <div className="br-pageheader pd-y-12 pd-l-30">
                <Breadcrumb {...props}/>
            </div>{/* br-pageheader */}
            {/* <div className="pd-x-20 pd-sm-x-30 pd-t-8 pd-sm-t-8">
                <h4 className="tx-gray-800 mg-b-4 mg-t-4 mg-sm-t-0">{props.pagename}</h4>
            </div> */}
            <div className="br-pagebody">
                <div className="card shadow-base">
                    {props.children}
                </div>
            </div>
            <Footer />
        </div>
    </>)
}
export default Layout;